import Styled from './styled';
import MainTitle from '$layout/partials/MainTitle';
import InterestedEmail from '../InterestedEmail';

export default function TopSection() {
  return (
    <Styled>
      <header>
        <MainTitle subTitle="Fixter is proud to partner with a diverse range of innovative industry leaders.">
          Our partners
        </MainTitle>
      </header>
      <InterestedEmail />
    </Styled>
  );
}
